import { createContext } from 'react'
import { DataContextProps } from './types'

export const DataContext = createContext<DataContextProps | undefined>(undefined)
